import { createRouter, createWebHistory } from 'vue-router'
import i18n from '../plugins/i18n'
import Home from '../views/zh/Home.vue'
import About from '../views/zh/About.vue'
import Contact from '../views/zh/Contact.vue'
import Services from '../views/zh/Services.vue'
import Subpage1 from '../views/zh/Subpage1.vue'
import Subpage2 from '../views/zh/Subpage2.vue'
import Subpage3 from '../views/zh/Subpage3.vue'
import Subpage4 from '../views/zh/Subpage4.vue'
import HomeEn from '../views/en/Home.vue'
import AboutEn from '../views/en/About.vue'
import ContactEn from '../views/en/Contact.vue'
import ServicesEn from '../views/en/Services.vue'


const routes = [
  { path: '/', component: Home },
  
  { path: '/en', component: HomeEn },
  { path: '/en/about', component: AboutEn },
  { path: '/en/contact', component: ContactEn },
  { path: '/en/services', component: ServicesEn },

  { path: '/:lang(en|zh)', component: Home },
  { path: '/:lang(en|zh)/about', component: About },
  { path: '/:lang(en|zh)/contact', component: Contact },
  { path: '/:lang(en|zh)/services', component: Services },
  { path: '/:lang(en|zh)/services/audit', component: Subpage1 },
  { path: '/:lang(en|zh)/services/tax', component: Subpage2 },
  { path: '/:lang(en|zh)/services/accounting', component: Subpage3 },
  { path: '/:lang(en|zh)/services/consulting', component: Subpage4 },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: About } // 通配符路由，放在最后
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const preferredLangSetting = navigator.language || navigator.userLanguage // 获取浏览器的默认语言
  const browserLang = preferredLangSetting.split('-')[0] // 只取语言部分，如 'en' 或 'zh'

  if (to.path === '/') {
    if(browserLang === 'zh' || browserLang === 'en')
      next(`/${browserLang}`)
    else
      next('/zh')
  } else {
    try {
      const langRegex = /(?<=^\/)(en|zh)(?=($|\/))/
      const match = to.fullPath.match(langRegex)
      const pathLang = match ? match[1] : 'zh' // 如果没有匹配到语言，默认
      i18n.global.locale = pathLang; // 设置全局语言
      next()
    } catch (error) {
      console.error('Error in route guard:', error);
      next({ path: '/zh' }); // 重定向到首页或其他默认页面
    }
  }
})

export default router